import { gql, TypedDocumentNode } from 'apollo-angular';

export class Queries {
  
  public static GetPaginatedCompanyNews(all: boolean): TypedDocumentNode {
    if (all) {
      return gql `query CompanyNews($first: Int, $after: String) {
        companyNews(
          first: $first,
          after: $after,
          order: {
            date: DESC
          }
        ) {
          nodes {
            id
            category
            date
            title
            excerpt
            content
            contentDelta
            thumbnailFileName
            thumbnailUrl
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;
    } else {
      return gql `query CompanyNews($categories: [NewsCategory!], $first: Int, $after: String) {
        companyNews(
          first: $first,
          after: $after,
          where: {
            category: {
              in: $categories
            }
          }
          order: {
            date: DESC
          }
        ) {
          nodes {
            id
            category
            date
            title
            excerpt
            content
            contentDelta
            thumbnailFileName
            thumbnailUrl
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;
    }
  }
}